import { render } from "./VerbalHooks.vue?vue&type=template&id=700e9e88"
import script from "./VerbalHooks.vue?vue&type=script&lang=js"
export * from "./VerbalHooks.vue?vue&type=script&lang=js"

import "./VerbalHooks.vue?vue&type=style&index=0&id=700e9e88&lang=css"

import exportComponent from "/var/www/ab-front-library/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__